module.exports = __webpack_public_path__ + "img/index-top-bg.d8dd3189.png";